export default __webpack_public_path__ + "static/media/instacrap2014.99dd6034.jpg";